<i class="fas fa-arrow-alt-circle-down baixa" title="{{prioridadeDescricao}}" *ngIf="prioridade == 1"></i>
<i class="fas fa-minus-circle media" title="{{prioridadeDescricao}}" *ngIf="prioridade == 2"></i>
<i class="fas fa-arrow-alt-circle-up alta" title="{{prioridadeDescricao}}" *ngIf="prioridade == 3"></i>